'use client'

import { useSession } from 'next-auth/react'
import { useRouter, usePathname } from 'next/navigation'
import { SessionProvider } from 'next-auth/react'
import { useEffect } from 'react'
import MapLoading from '@/components/MapLoading'

const AuthCheck = ({ children }: { children: React.ReactNode }) => {
  const { data: session, status } = useSession()
  const router = useRouter()
  const pathname = usePathname()

  const publicPaths = ['/', '/login', '/register', '/about', '/news', '/column', '/search', '/map', '/web', '/kosenoba-map', '/signup']

  useEffect(() => {
    if (status === 'loading') return

    if (!session && !publicPaths.includes(pathname)) {
      router.push('/login')
    }
  }, [session, status, router, pathname])

  if (status === 'loading') {
    return <MapLoading message="読み込み中..." />
  }

  return <>{children}</>
}

export default function ClientProvider({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <SessionProvider>
      <AuthCheck>{children}</AuthCheck>
    </SessionProvider>
  )
}
